import { Dropdown } from '../Dropdown';
import { ErrorText } from '../ErrorText';
import { DropdownColumn, ErrorRow, Label, Row } from './TimeslotRow.styles';
import type { TimeslotRowProps } from './TimeslotRow.types';

export function TimeslotRow({
  label,
  timeslots,
  selectedTimeslot,
  onChange,
  timeslotPlaceholder = 'Time*',
  ariaLabelFormatter = (l) => `${l} time`,
  disabled,
  error,
}: TimeslotRowProps) {
  const hasTimeslots = timeslots.length > 0;

  return (
    <Row data-disabled={disabled || undefined} data-no-timeslots={!hasTimeslots || undefined}>
      <Label>{label}</Label>
      {hasTimeslots && (
        <DropdownColumn>
          <Dropdown
            options={timeslots}
            value={selectedTimeslot}
            placeholder={timeslotPlaceholder}
            onChange={onChange}
            aria-label={ariaLabelFormatter(label)}
            disabled={disabled}
            hasError={!!error}
          />
          {error && (
            <ErrorRow>
              <ErrorText>{error}</ErrorText>
            </ErrorRow>
          )}
        </DropdownColumn>
      )}
    </Row>
  );
}
